import TldlCard from './TldlCard';

export default TldlCard;
